import React, {
  useEffect,
  useState
} from "react";
import CheckBoxComp from "../components/checkboxcomp";
import ButtonPlusComp from "../components/buttonpluscomp";



const ListComp =(props)=>{

var {
  grandchild,
  title,
  list,
  type,
  sendData,
  deleteData,
  sendFamily,
  deleteFamily
} = props

const [facts, setFacts] = useState({});
const [conclusions, setConclusions] = useState([]);


    const [isShow, setShowResults] = React.useState(false);
    const onClick = () => setShowResults(isShow ? false : true);
    const handleDiscard = (id, name, value) => {
      pushToEntitiesDiscarded([id]);
    };


    var grandchildcomp;
    var listcomp;
    var  [isChecked, setIsChecked] = useState(Array.from({ length: 100 }).fill(false));

   if(grandchild){
        grandchildcomp = <div className="pl-0">
            {
              grandchild.map((grand) => {
        return (
          <CheckBoxComp
            key={grand.id}
            item={grand.image}
            value={grand.id}
            title={grand.name}
            isChecked={isChecked[grand.id]}
            onChange = {
                type == 1 ?
                (e) => {
                isChecked[grand.id] ?  deleteFamily(grand.id):sendFamily(grand.id);
                setIsChecked((prevChecked) => ({
                  ...prevChecked,
                  [grand.id]: !prevChecked[grand.id],
                }));
                }: (e) => {
                  isChecked[grand.id] ?  deleteData(grand.id, grand.value):sendData(grand.id,grand.value);
                  setIsChecked((prevChecked) => ({
                    ...prevChecked,
                    [grand.id]: !prevChecked[grand.id],
                  }));
                }
                }
          />
        );
      })}

        </div>
    }

    if(list){
        listcomp = <div className="pl-0">
            {list.map((list)=>(
                <div key={list.id} className="pl-5">
                    <p>{list.name}</p>
                </div>
                
            ))}
        </div>
    }
    
    return (
    <div>
        <ButtonPlusComp title={title} click={onClick} isClicked={isShow} />
        {isShow ? grandchildcomp : null}
        {isShow ? listcomp : null}
        
        
    </div>)

}

export default ListComp